export default {
    root: {
      name: 'aulas-teoricas',
      displayName: 'Home',
      disabled: true,
    },
    routes: [
      {
        displayName: 'Aulas Teóricas',
        disabled: true,
        name: 'aulas-teoricas'
      },
      {
        displayName: 'Aulas Práticas',
        disabled: true,
        name: 'aulas-praticas'
      }
    ]
  }
